<template>
	<!--概念孵化-->
	<div class="tempD" :style="{minHeight:tempH}">
		<div class="listD" style="display: flex;flex-direction: row;">
			<concactus></concactus>
			<div class="arr_itemBox" style="width: 100%;">
				<div class="arr_item" v-for="da in dataArr">
					<!--<div class="arr_item_it" @click="seeInfo(da)">{{da.title}}</div>
				<div class="arr_item_it">{{da.create_time}}</div>-->
					<div style="width: 30%;min-width: 30%;" class="imgd" :style="{backgroundImage:'url('+imageUrl+da.pic+')'}">

					</div>
					<div class="titAcontent" @click="seeInfo(da)">
						<div class="titl">{{da.title}}</div>
						<div class="ctime">{{da.create_time}}</div>
						<div class="fu_titl">
							{{da.subtitle}}
						</div>
					</div>
				</div>
				<div class="paging" v-if="pageTotal>10">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-size="100" layout="total, prev, pager, next, jumper" :total="pageTotal"></el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const concactus = () =>
		import("@/components/home/common/contactUs.vue"); //作品详情
	export default {
		components: {
			concactus
		},
		data() {
			return {
				imageUrl:'http://www.1522znsj.com',
				selectIndex: 2,
				tempH: 0,
				classId: 0,
				dataArr: [],
				pageNum: 1,
				pageTotal: 0,
				concatUsObj: {},
			}
		},
		created: function() {
			let _this = this;
			_this.classId = _this.$route.query.class_id;
			_this.getArr_api(_this.classId);
		},
		mounted: function() {
			let _this = this;
			let offsetHeight = document.documentElement.clientHeight - 250 + 'px';
			_this.tempH = offsetHeight;
		},
		methods: {
			/*获取列表
			 创建于2019-11-25  作者：郑凯*/
			getArr_api(id) {
				let _this = this;
				let paramsObj = {
					"pageNumber": _this.pageNum,
					"limit5": 10,
					"class_id": id
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentListByClassId',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.dataArr = resObj.data.data;
						_this.pageNum = resObj.data.pageNumber;
						_this.pageTotal = resObj.data.total;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				let _this = this;
				_this.pageNum = val;
				_this.getArr_api(_this.classId);
			},
			/**  * -----查看详情
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seeInfo(obj) {
				let _this = this;
				const {
					href
				} = this.$router.resolve({
					path: '/twoLevelPage',
					query: {
						content_id: obj.content_id,
						type: _this.classId
					}
				})
				window.open(href, '_blank')
			},
			/**  * -----去往其他栏目
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			openClassfy(type) {
				let _this = this;
				_this.selectIndex = type;
				switch(type) {
					case 0:
						_this.$router.push('/homePage');
						break;
					case 1:
						_this.$router.push({
							name: 'conceptIncubation',
							query: {
								class_id: '1'
							}
						});
						break;
					case 2:
						_this.$router.push({
							name: 'talentService',
							query: {
								class_id: '2'
							}
						});
						break;
					case 3:
						_this.$router.push({
							name: 'eventExhibition',
							query: {
								class_id: '3'
							}
						});
						break;
					case 4:
						_this.$router.push({
							name: 'designCrowdsourcing',
							query: {
								class_id: '4'
							}
						});
						break;
					case 5:
						_this.$router.push({
							name: 'newsAndInformation',
							query: {
								class_id: '5'
							}
						});
						break;
					case 6:
						_this.$router.push({
							name: 'policiesAndRegulations',
							query: {
								class_id: '6'
							}
						});
						break;
				}
			},
		}
	}
</script>

<style scoped>
	.tempD{ width: 100%;}
	.listD{
		/*border: 1px solid #ccc;*/
		width: 90%; min-height: 50px; margin: auto; margin-top: 20px;}
	.arr_item{ padding: 10px; display: flex; flex-direction: row;
		/*background-color: rgb(236,236,238);*/
		background-color: #fcfcfc; margin-bottom: 5px;height: 140px;}
	.imgd{ width: 28%; background-repeat: no-repeat; background-position: center; background-size: cover; background-color: #fff;}
	.titAcontent{ padding: 0 0 0 20px; cursor: pointer;}
	.titl{ font-size: 18px;}
	.ctime{ font-size: 12px; padding: 10px 0;}
	.fu_titl{ margin-top: 5px; padding: 20px 0 0 0;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2; overflow: hidden;}
	.arr_item .arr_item_it:nth-child(1){ flex: 1; white-space: nowrap; cursor: pointer;}
	.arr_item .arr_item_it:nth-child(1):hover{ color: blue;}
	.arr_item .arr_item_it:nth-child(2){ width: 150px; text-align: right; color: #666; font-size: 12px;}
	.paging{ text-align: right; padding: 30px;}

</style>